module.exports = __webpack_public_path__ + "static/media/SMM.1a90c826.svg";